import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState  } from 'react';
import { Button, Col, Container, Row, Modal, Tooltip  } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import BalanceHistory from '../../../components/BalanceHistory'

export type DentalBalanceModalProps = {
    show: boolean;
    handleClose: () => void;
  };

const balanceHistories = [
    {
      balance:31.64,
      newCharges:0.00,
      balanceTotal:31.64,
      lastPayment:2.88,
      lastPaymentDate:'09/08/2023',
      outstandingBalance:28.76,
      approxRemainingPayments:'10',
      reason:'Past outstanding balance rolled over'
    },
    {
      balance:0.00,
      newCharges:34.52,
      balanceTotal:34.52,
      lastPayment:2.88,
      lastPaymentDate:'08/25/2023',
      outstandingBalance:31.64,
      approxRemainingPayments:'11',
      reason:'Mismatch between deductions reported versus deductions taken for pay date = 08/11/2023'
    },
]

  
const DentalBalanceModal = ({
    show,
    handleClose,
  }: DentalBalanceModalProps) => {
  const [showMore, setShowMore] = React.useState<boolean>(false);

  const toggleShowMore = (e: any) => {
    setShowMore(!showMore);
  };

  return (
    <>
    <Modal size="xl" show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            <h5>Balance History</h5>
            <div className={'row pl-15 pr-15 pt-15 h6 text-fs-6'}>
              <span>
                <b>Dental</b> (Before-Tax)
              </span>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            className={
              'd-sm-none d-lg-flex row pb-5 fb hidden-xs hidden-sm sticky-row'
            }
          >
            <div className={'col-sm-1 col-md-1 col-lg-1 w-lg-12'}>
              <b>Balance</b>
              <OverlayTrigger overlay={<Tooltip>Benefit Info</Tooltip>}>
                {({ ref, ...triggerHandler }) => (
                  <span className="ms-1" ref={ref} {...triggerHandler}>
                    <FontAwesomeIcon icon={light('circle-exclamation')} />
                  </span>
                )}
              </OverlayTrigger>
            </div>
            <div className={'col-sm-1 col-md-1 col-lg-1 w-lg-16'}>
              <b>New Charges</b>
              <OverlayTrigger overlay={<Tooltip>New Charges Info</Tooltip>}>
                {({ ref, ...triggerHandler }) => (
                  <span className="ms-1" ref={ref} {...triggerHandler}>
                    <FontAwesomeIcon icon={light('circle-exclamation')} />
                  </span>
                )}
              </OverlayTrigger>
            </div>
            <div className={'col-sm-1 col-md-1 col-lg-2'}>
              <b>Balance Total</b>
              <OverlayTrigger overlay={<Tooltip>Balance Total Info</Tooltip>}>
                {({ ref, ...triggerHandler }) => (
                  <span className="ms-1" ref={ref} {...triggerHandler}>
                    <FontAwesomeIcon icon={light('circle-exclamation')} />
                  </span>
                )}
              </OverlayTrigger>
            </div>
            <div className={'col-sm-1 col-md-1 col-lg-2 w-lg-12'}>
              <b>Last Payment Details</b>
              <OverlayTrigger
                overlay={<Tooltip>Last Payment Details Info</Tooltip>}
              >
                {({ ref, ...triggerHandler }) => (
                  <span className="ms-1" ref={ref} {...triggerHandler}>
                    <FontAwesomeIcon icon={light('circle-exclamation')} />
                  </span>
                )}
              </OverlayTrigger>
            </div>
            <div className={'col-sm-1 col-md-1 col-lg-2'}>
              <b>Outstanding Balance Details</b>
              <OverlayTrigger
                overlay={<Tooltip>Outstanding Balance Info</Tooltip>}
              >
                {({ ref, ...triggerHandler }) => (
                  <span className="ms-1" ref={ref} {...triggerHandler}>
                    <FontAwesomeIcon icon={light('circle-exclamation')} />
                  </span>
                )}
              </OverlayTrigger>
            </div>
            <div className={'col-sm-1 col-md-1 col-lg-2 w-lg-13'}>
              <b>Approx Remaining Payments</b>
              <OverlayTrigger
                overlay={<Tooltip>Approx Remaining Payments Info</Tooltip>}
              >
                {({ ref, ...triggerHandler }) => (
                  <span className="ms-1" ref={ref} {...triggerHandler}>
                    <FontAwesomeIcon icon={light('circle-exclamation')} />
                  </span>
                )}
              </OverlayTrigger>
            </div>
            <div className={'col-sm-1 col-md-1 col-lg-2 w-lg-13'}></div>
          </div>
          {balanceHistories.map((history) => {
            return (
              <BalanceHistory
              {...history} 
              />
            )
          })}
          
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default DentalBalanceModal